import { render, staticRenderFns } from "./AllergiesForm.vue?vue&type=template&id=d4340e70"
import script from "./AllergiesForm.vue?vue&type=script&lang=js"
export * from "./AllergiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports